import { render, staticRenderFns } from "./StockMovementsTable.vue?vue&type=template&id=13cd9c46&scoped=true"
import script from "./StockMovementsTable.vue?vue&type=script&lang=js"
export * from "./StockMovementsTable.vue?vue&type=script&lang=js"
import style0 from "./StockMovementsTable.vue?vue&type=style&index=0&id=13cd9c46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cd9c46",
  null
  
)

export default component.exports